export const getBrowserNotification = () => {
  if (typeof window === 'undefined' || typeof window.Notification !== 'function') {
    return null;
  }

  return window.Notification;
};

export const showBrowserNotification = (title, options = {}) => {
  const BrowserNotification = getBrowserNotification();
  if (BrowserNotification?.permission !== 'granted') {
    return null;
  }

  try {
    return new BrowserNotification(title, options);
  } catch (error) {
    return null;
  }
};

export const requestBrowserNotificationPermission = () => {
  const BrowserNotification = getBrowserNotification();
  if (
    !BrowserNotification
    || BrowserNotification.permission === 'denied'
    || typeof BrowserNotification.requestPermission !== 'function'
  ) {
    return Promise.resolve(null);
  }

  try {
    return Promise.resolve(BrowserNotification.requestPermission()).catch(() => null);
  } catch (error) {
    return Promise.resolve(null);
  }
};
